import { default as React } from 'react'
import { images } from '../../../assets'

// export const ServiceFee = () => {
//   return (
//     <div className="contents center">
//       <div className="service_fee_wrap">
//         <div>
//           <div className="fee_tit">
//             <p className="sub_tit">기본 1채널</p>
//             <p className="tit">
//               <span className="fee">40,000</span>원/월
//             </p>
//           </div>
//           <div>
//             <img src={images.img_plus} alt={images.img_plus} />
//           </div>
//           <div className="fee_tit">
//             <p className="sub_tit">추가 채널당</p>
//             <p className="tit">
//               <span className="fee">10,000</span>원/월
//             </p>
//           </div>
//         </div>
//         <p>*부가세 별도</p>
//       </div>
//     </div>
//   )
// }

const PriceRow = ({ text }) => {
  const [a, b, c] = text
  return (
    <div className="price-row">
      <div className="fee_tit">
        <p className="tit fee-tit-left">
          <span className="fee">{a}</span>
          <span className="fee">~</span>
          <span className="fee">{b}</span>
        </p>
      </div>
      <div className="arrow">
        <picture>
          <source media="(min-width: 1024px)" srcSet={images.arrow_right_large} />
          <img src={images.arrow_right} alt={images.arrow_right} />
        </picture>
        {/* <img src={images.arrow_right} alt={images.arrow_right} /> */}
      </div>
      <div className="fee_tit">
        <p className="tit">
          <span className="fee">{c}</span>
        </p>
      </div>
    </div>
  )
}

export const ServiceFee = () => {
  return (
    <div className="contents center">
      <div className="service_fee_wrap">
        <div className="price-rows">
          <div className="price-row" style={{ marginBottom: '10px' }}>
            <div className="fee_tit">
              <p className="sub_tit">리뷰 개수 (개/월)</p>
            </div>
            <div className="arrow"></div>
            <div className="fee_tit">
              <p className="sub_tit">서비스 비용 (원/월)</p>
            </div>
          </div>
          <PriceRow text={['', '30', '10,000']} />
          <PriceRow text={['31', '60', '20,000']} />
          <PriceRow text={['61', '120', '30,000']} />
          <PriceRow text={['121', '300', '40,000']} />
          <PriceRow text={['301', '450', '50,000']} />
          <PriceRow text={['451', '', '60,000']} />
        </div>

        <p>*부가세 10% 별도</p>
      </div>
    </div>
  )
}
